import { apiFuns } from "sw-hic";
let { get, post, put, del, genStandard } = apiFuns;
let api = {
     SetDetailId : {
        ...genStandard("standard","/api/therapy"),
     },
     TherapyItem : {
        ...genStandard("item","/api/therapy"),
     }   
};
export default api;
